import { Listing, ListingTemplate } from "@truckdown/locations";
import context from '@truckdown/components-systems';
import { defineComponent, ref, Ref, watch, PropType } from "vue";

interface IData {
    listingTemplateType: Ref<ListingTemplate | undefined>,
    overrideDefault: Ref<boolean>,
    selectedSite: Ref<string>
};

const getData = function (props: any) {
    return {
        listingTemplateType: ref<ListingTemplate | undefined>(props.listingTemplateType),
        overrideDefault: ref<boolean>(props.overrideDefault),
        selectedSite: ref<string>(props.selectedSite)
    } as IData;
}

const getMethods = function (ctx: any) {
    return {
        openEditModal: function (type: string, step?: number, tab?: number) {
            ctx.emit('open-edit-modal', type, step || 1, tab || 1)
        },
        openHours: function () {
            ctx.emit('open-hours');
        }
    };
}


export default defineComponent({
    name: "ListingTemplateSelectorWrapper",
    props: {
        listing: Object as () => Listing,
        list: String,
        allServices: Array,
        showDetail: Boolean,
        enableMap: Boolean,
        disableActions: Boolean,
        editable: {
            type: Boolean,
            default: false,
        },
        adminView: {
            type: Boolean,
            default: false,
        },
        isAdmin: {
            type: Boolean,
            default: false,
            required: false
        },
        listingTemplateType: {
            type: Number as PropType<ListingTemplate>,
            required: false
        },
        selectedSite: {
            type: String,
            required: false,
            default: context.system
        },
        overrideDefault: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    emits: ['open-edit-modal', 'open-hours'],
    setup: function (props, ctx) {
        const data = getData(props);
        const methods = getMethods(ctx);

        watch<[ListingTemplate | undefined ,string, boolean]>(
            () => [props.listingTemplateType, props.selectedSite, props.overrideDefault],
            ([newType, newSelectedSite, newOverrideDefault]) => {
                data.listingTemplateType.value = newType;
                data.overrideDefault.value = newOverrideDefault;
                data.selectedSite.value = newSelectedSite;
            }
        );

        return {
            ...data,
            ...methods
        };
    }
});